import { gql } from '@apollo/client'

export const ADD_VACCINATION = gql`
  mutation AddVaccination($inputData: AddVaccinationInput!) {
    addVaccination(inputData: $inputData) {
      id
    }
  }
`
